"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../../core/model/DomainObject");

var ApprovalStatusIndication_1 = require("./ApprovalStatusIndication");

var RoleApprovalStatus_1 = require("./RoleApprovalStatus");
/**
 * Approval status of release part.
 * @author Radek Beran
 */


var ApprovalStatus =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ApprovalStatus, _DomainObject_1$Domai);

  function ApprovalStatus(roleStatuses) {
    var _this;

    _classCallCheck(this, ApprovalStatus);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ApprovalStatus).call(this));
    _this.roleStatuses = roleStatuses;
    return _this;
  }
  /**
   * Creates initial instance of approval status for given roles that take part on the workflow process.
   * @param roles
   */


  _createClass(ApprovalStatus, null, [{
    key: "initialForRoles",
    value: function initialForRoles(roles) {
      return new ApprovalStatus(roles.map(function (role, index) {
        return new RoleApprovalStatus_1.RoleApprovalStatus(role, index === 0 ? ApprovalStatusIndication_1.ApprovalStatusIndication.InProgress : ApprovalStatusIndication_1.ApprovalStatusIndication.Waiting, null);
      }));
    }
  }]);

  return ApprovalStatus;
}(DomainObject_1.DomainObject);

exports.ApprovalStatus = ApprovalStatus;
ApprovalStatus.EMPTY = new ApprovalStatus(immutable_1.List.of());